module.exports = __webpack_public_path__ + "static/small icons-07-b619de8a7ccf3f105e715b5f261e942f.png";